import {
  getUniqueEmployeeListRequest,
  removeEmployeeFromModuleRequest,
  removeEmployeeFromPayScheduleRequest,
} from '@vyce/core/src/api/pay';
import { EmployeeList } from '@vyce/core/src/views/payroll/components';
import { WidgetWrapper, WidgetWrapperProps } from '@vyce/core/src/components/Dashboard/WidgetWrapper';

import { useTypedSelector } from 'src/hooks';

export const EmployeeListWidget = (props: WidgetWrapperProps) => {
  const { selectedCompany, access_token, selectedCompanyAppData } = useTypedSelector(state => state.helper);

  return (
    <WidgetWrapper {...props}>
      <EmployeeList
        token={access_token}
        removeEmployeeFromPayScheduleRequest={removeEmployeeFromPayScheduleRequest}
        removeEmployeeFromModuleRequest={removeEmployeeFromModuleRequest}
        companyId={selectedCompany?.uuid}
        paySchedules={selectedCompanyAppData?.paySchedules}
        getEmployeeListRequest={getUniqueEmployeeListRequest}
        withProfileButton
        showPaySchedule={false}
        height="calc(100% - 40px)"
      >
        <></>
      </EmployeeList>
    </WidgetWrapper>
  );
};
